module.exports = __webpack_public_path__ + "media/images/Carpentry Services Hero2-059e025f.jpg";